import 'react-image-lightbox/style.css';

import { Alert } from '@nect/ui/component/alert';
import { HeadlineH3Bold } from '@nect/ui/component/headline';
import { IconHomeExternalLinkOutline } from '@nect/ui/component/icon/auto/home-external-link-outline';
import { TextBodyRegularSpan } from '@nect/ui/component/text';
import { Color } from '@nect/ui/theme/color';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Lightbox from 'react-image-lightbox';
import { useParams } from 'react-router-dom';
import { DarkButton } from 'src/components/DarkButton';
import { routes } from 'src/constants/constants';
import styled from 'styled-components';

import { FaqStyled } from '../components/faq/Faq.styled';
import { FaqQuestion } from '../components/faq/FaqQuestion';
import { SubCategoryButton } from '../components/faq/SubCategoryButton';
import { Footer } from '../components/Footer/Footer';
import { Header } from '../components/Header/Header';
import { getFaqContent } from '../helper/getFaqContent';
import { useLocation } from '../react-router-hooks';

const AlertStyled = styled(Alert)`
  margin-bottom: ${({ theme }) => theme.spacing.XXS};

  :hover {
    background-color: ${({ theme }) => theme.color[Color.grey100]};
    color: ${({ theme }) => theme.color[Color.grey700]};
  }
`;

export const FaqSubCategoryScreen = () => {
  const { t } = useTranslation();

  const { idCategory } = useParams();
  const [showImageFullScreen, setShowImageFullScreen] = useState(false);
  const [imageFullScreen, setImageFullScreen] = useState('');
  const { location } = useLocation();
  const [paramsState, setParamsState] = useState<any>();
  const faqContent = getFaqContent();
  const content = faqContent[idCategory];

  useEffect(() => {
    window.scrollTo(0, 0);
    setParamsState(location.state);
  }, []);

  return (
    <div className="root">
      <Header />
      <div id="main" className="main" style={{ paddingTop: 73 }}>
        <FaqStyled.NavigationMainContainer>
          <FaqStyled.NavigationContainer>
            <img src={require('../assets/faqhome.svg')} />
            <FaqStyled.NavigationText
              to={{ pathname: routes.HOME, state: paramsState }}
            >
              {t('Start ')}
            </FaqStyled.NavigationText>
            <FaqStyled.Divider>
              <img
                height={16}
                width={16}
                src={require('../assets/navigation_separator.svg')}
              />
            </FaqStyled.Divider>
            <FaqStyled.NavigationText
              to={{
                pathname: content.companyName
                  ? routes.FAQSELECTION
                  : routes.FAQMAIN,
                state: paramsState
              }}
            >
              {content.companyName ? content.companyName : content.mainCategory}
            </FaqStyled.NavigationText>
          </FaqStyled.NavigationContainer>
        </FaqStyled.NavigationMainContainer>
        {showImageFullScreen && (
          <Lightbox
            mainSrc={require(`../assets/${imageFullScreen}`)}
            onCloseRequest={() => setShowImageFullScreen(false)}
          />
        )}
        <FaqStyled.ContainerMain style={{ marginTop: 80 }}>
          <FaqStyled.Container>
            {content.companyName ? (
              <>
                <HeadlineH3Bold>
                  {t('Questions and answers about our partner companies')}
                </HeadlineH3Bold>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: 40,
                    marginBottom: 25
                  }}
                >
                  <img
                    width={64}
                    src={content.companyLogo}
                    style={{ marginRight: 24 }}
                  />
                  <TextBodyRegularSpan>
                    {content.companyName}
                  </TextBodyRegularSpan>

                  <div
                    style={{
                      flexGrow: 1,
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <DarkButton
                      style={{ alignSelf: 'flex-end' }}
                      onClick={() => {
                        window.open(content.companyURL, '_blank');
                      }}
                    >
                      {content.companyURLButton}
                      <IconHomeExternalLinkOutline
                        size={16}
                        color={Color.white100}
                        style={{ marginLeft: 8 }}
                      />
                    </DarkButton>
                  </div>
                </div>
              </>
            ) : (
              <>
                <FaqStyled.TitlePage>{content.title}</FaqStyled.TitlePage>
                <FaqStyled.SubTitle>
                  {content.generalMessage}
                </FaqStyled.SubTitle>
              </>
            )}
            {content?.subCategories?.map((item, index) => (
              <SubCategoryButton
                key={index}
                icon={require(`../assets/${item.icon}`)}
                title={item.title}
                to={{
                  pathname:
                    item?.url ??
                    routes.FAQCONTENT.replace(
                      ':idCategory',
                      idCategory
                    ).replace(':idSubCategory', item.title),
                  state: paramsState
                }}
              />
            ))}
            {content.generalMessage2 && (
              <FaqStyled.SubTitle style={{ marginTop: 24 }}>
                {content.generalMessage2}
              </FaqStyled.SubTitle>
            )}
            {content.questions && (
              <>
                {content.questions.length > 3 &&
                  content.questions.map((item, index) => (
                    <AlertStyled
                      onClick={() => (window.location.href = '#' + index)}
                      type="info"
                      hideIcon={true}
                      key={index}
                    >
                      {item.question}
                    </AlertStyled>
                  ))}
                <br />
                {content.questions.map((item, index) => (
                  <FaqQuestion question={item} key={index} id={index} />
                ))}
              </>
            )}
          </FaqStyled.Container>
        </FaqStyled.ContainerMain>
      </div>
      <Footer />
    </div>
  );
};
